// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2umDG","select":"Header_select__3ZedX","clinic":"Header_clinic__H5_IY"};